export default {
  methods: {
    handlePrefillFormKey() {},
  },
};
